import { cloneDeep } from 'lodash'
import { Managment, Activations, Accounts } from '@payu/paymentsos-types'

import ApiBase from './ApiBase'

class AccountsApi extends ApiBase {
  fetchAccount = async (accountId = this.accountId): Promise<Managment.AccountResource> => {
    const response = await this.httpClient.get<Managment.AccountResource>(
      `/accounts/${accountId}`,
      {},
      this.defaultConfig
    )
    return response.data
  }

  fetchConnectedAccounts = async (accountId = this.accountId): Promise<Accounts.ConnectedAccountsResponse> => {
    const response = await this.httpClient.get<Accounts.ConnectedAccountsResponse>(
        `/accounts/${accountId}/connected-accounts`,
        {},
        this.defaultConfig
    )
    return response.data
  }

  activateAccount = async (
    accountDetails: Activations.PostActivation
  ): Promise<Activations.ActivationResource> => {
    const config = cloneDeep(this.defaultConfig)
    delete config.headers['x-payments-os-env']

    const response = await this.httpClient.post<Activations.ActivationResource>(
      `/accounts/${this.accountId}/activations`,
      accountDetails,
      {},
      config
    )

    return response.data
  }

  activateAccountInternal = async (
    accountDetails: Activations.PostInternalActivation
  ): Promise<Activations.InternalActivationResource> => {
    const config = cloneDeep(this.defaultConfig)
    delete config.headers['x-payments-os-env']

    const response = await this.httpClient.post<Activations.InternalActivationResource>(
      `/accounts/${this.accountId}/internal-activations`,
      accountDetails,
      {},
      config
    )

    return response.data
  }

  updateActivation = async (
    accountDetails: Activations.PutActivation
  ): Promise<Activations.ActivationResource> => {
    const response = await this.httpClient.put<Activations.ActivationResource>(
      `/accounts/${this.accountId}/activations`,
      accountDetails,
      {},
      this.defaultConfig
    )

    return response.data
  }

  fetchAccountActivations = async (
    accountId = this.accountId
  ): Promise<Activations.ActivationResource> => {
    const response = await this.httpClient.get<Activations.ActivationResource>(
      `/accounts/${accountId}/activations`,
      {},
      this.defaultConfig
    )

    return response.data
  }
}

export default new AccountsApi()
